var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidemenuBgBottomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 235,
    viewBox: "0 0 207 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1706_33285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-128.019 59.3648L-144.487 39.3977C-149.258 33.5924 -147.91 25.1318 -141.603 20.9144C-105.864 -2.98362 -62.9552 -16 -19.2919 -16C24.3714 -16 67.2799 -2.98362 102.992 20.9144C109.299 25.1318 110.674 33.5924 105.876 39.3977L89.4081 59.3648C85.1226 64.5453 77.4141 65.7429 71.7541 62.0202C44.9093 44.2919 13.6711 34.9721 -19.2919 34.9721C-52.255 34.9721 -83.4931 44.2919 -110.338 62.0202C-115.998 65.7689 -123.706 64.5453 -127.992 59.3648H-128.019Z",
    fill: "#0D968F",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.004 312.246L117.332 296.34C111.968 292.201 110.728 284.756 114.583 279.289C132.937 253.36 142.586 223.188 142.586 191.35C142.586 162.636 134.608 134.963 119.407 110.675C115.849 104.973 117.44 97.5801 123.073 93.7273L144.635 78.9146C150.861 74.6453 159.513 76.3634 163.529 82.6373C184.39 115.282 195.36 152.587 195.36 191.35C195.36 233.523 181.883 274.967 157.141 309.461C152.774 315.552 144.015 316.88 138.004 312.246Z",
    fill: "#0D968F",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.2918 295.274C40.1313 295.274 88.3032 248.746 88.3032 191.351C88.3032 133.956 40.1313 87.4282 -19.2918 87.4282C-78.7148 87.4282 -126.887 133.956 -126.887 191.351C-126.887 248.746 -78.7148 295.274 -19.2918 295.274Z",
    fill: "#0D968F",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1706_33285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206.714,
    height: 300,
    fill: "white",
    transform: "translate(0 -16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenuBgBottomIcon);
export default __webpack_public_path__ + "static/media/sidemenu-bg-bottom-icon.030bef195203b0ab43fa260298de6e9e.svg";
export { ForwardRef as ReactComponent };